function QuickBox({ title, children }: { title: string; children?: React.ReactElement }) {
    return (
        <span className="text-base">
            {title} : {children}{' '}
        </span>
    );
}

export default QuickBox;
